module.exports = '4.13.1';



// WEBPACK FOOTER //
// ./src/version.js